























































import { Component, Mixins } from "vue-property-decorator";
import { ContractIdValidatorMixin } from "@/mixins/ContractIdValidatorMixin";
import MonthPicker from "@/components/ui/MonthPicker.vue";
import PaymentsItem from "@/components/ui/PaymentsItem.vue";
import moment from "moment";
import { ContractsModule } from "@/store/contracts.module";
import { TableReportsService } from "@/services/api/tableReports.service";
import { ReportService } from "@/services/api/reports.service";

@Component({
  components: { MonthPicker, PaymentsItem },
})
export default class PaymentsView extends Mixins(ContractIdValidatorMixin) {
  from = "";
  to = "";
  current = "";
  loading = false;
  async mounted() {
    await this.validateContractId();
    this.current = moment().format("YYYY-MM");
    this.from = moment().format("YYYY-MM");
    this.to = this.current;
  }

  async showButtonHandleClick() {
    this.loading = true;
    const contractRid = ContractsModule.selectedContract;
    const data = (
      await ReportService.getReportContractPayments(
        Number(contractRid),
        `${moment(this.from, "YYYY-MM")
          .startOf("month")
          .format("YYYYMMDD")}`,
        `${moment(this.to, "YYYY-MM")
          .endOf("month")
          .format("YYYYMMDD")}`,
      )
    ).data;

    const binaryData = atob(data);
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    this.loading = false;

    const blob = new Blob([uint8Array], { type: "application/pdf" });

    // Создаем URL для Blob-объекта
    const url = window.URL.createObjectURL(blob);

    // Открываем файл в новом окне или вкладке
    window.open(url);
  }

  get labels() {
    return [
      "serv_electricity",
      "serv_fine",
      "serv_duty",
      "serv_reconnect",
      "calcs",
    ];
  }
}
